import { ModalName } from '@bg-shared/enums/ModalName';

export enum ContainerName {
    BODY = 'body',
    BETSLIP = 'betslip',
    DROPDOWN = 'dropdown',
    REPEAT_BETS = 'repeat_bets',
    BALL_SELECTION = 'ball_selection',
}

export type IContainerName = ContainerName | ModalName;

interface IItem {
    name: IContainerName;
    height: number;
}

export class HeightManager {
    private container = <IItem[]>[];

    public addOrUpdate(item: IItem): void {
        const index = this.container.findIndex((exItem) => exItem.name === item.name);

        if (index !== -1) {
            this.dropdownHandler(item);
            this.container[index] = item;
        } else {
            this.container.push(item);
        }
    }

    public remove(itemName: IContainerName): void {
        const index = this.container.findIndex((exItem) => exItem.name === itemName);

        if (index !== -1) {
            this.container.splice(index, 1);
        }
    }

    public getBiggestHeight(): number {
        return this.container.reduce((max, item) => (max > item.height ? max : item.height), 0);
    }

    private dropdownHandler(item: IItem): void {
        const dropdownIndex = this.container.findIndex(
            (exItem) => exItem.name === ContainerName.DROPDOWN,
        );
        const itemIndex = this.container.findIndex((exItem) => exItem.name === item.name);

        if (dropdownIndex !== -1 && itemIndex !== -1) {
            this.container[dropdownIndex].height += item.height - this.container[itemIndex].height;
        }
    }
}
